import { h } from 'preact'
/** @jsx h */

export const WizardMeta = ({ title, description }) => (
  <div className="c-quiz__meta u-squeeze--m">
    <h1 className="c-quiz__title">{title}</h1>
    <p className="c-quiz__description">{description}</p>
    <svg className="c-icon c-quiz__squiggle">
      <use href="#squiggle" xlinkHref="#squiggle" />
    </svg>
  </div>
)



// WEBPACK FOOTER //
// ./src/js/quiz/components/WizardMeta.jsx